import http from "../components/http";
import { IitemPedido } from "../interfaces/itemPedido";


// Função para buscar todos os itens de pedidos
export const fetchItensPedido = async (): Promise<IitemPedido[]> => {
  const response = await http.get(`/itens-pedido`);
  return response.data;
};

// Função para criar um novo item de pedido
export const createItemPedido = async (itemPedido: IitemPedido): Promise<IitemPedido> => {
  let response;
  try {
    response = await http.post(`/itens-pedido`, itemPedido);
  } catch (error) {
    console.log(error)
  }
  return response?.data;
};

// Função para atualizar um item de pedido existente
export const updateItemPedido = async (id: string, itemPedido: IitemPedido): Promise<IitemPedido> => {
  const response = await http.put(`/itens-pedido/${id}`, itemPedido);
  return response.data;
};

// Função para deletar um item de pedido
export const deleteItemPedido = async (id: string): Promise<void> => {
  await http.delete(`/itens-pedido/${id}`);
};
